export enum RegistrationAction {
    AcceptEventInfo = "AcceptEventInfo",
    ChangeDebitorProfile = "ChangeDebitorProfile",
    ResetRegistration = "ResetRegistration",
    RegisterBlankTeam = "RegisterBlankTeam",
    RegisterNamedTeam = "RegisterNamedTeam",
    SelectTeamUpdateTeam = "SelectTeamUpdateTeam",
    ChangeTeamCategory = "ChangeTeamCategory",
    ChangeTeamCategoryWithMembers = "ChangeTeamCategoryWithMembers",
    UpdateTeamMembersCount = "UpdateTeamMembersCount",
    ChangeTeamContactPerson = "ChangeTeamContactPerson",
    ChangeTeamName = "ChangeTeamName",
    DeleteTeam = "DeleteTeam",
    ValidateTeam = "ValidateTeam",
    FinalizeRegistration = "FinalizeRegistration",
    ToggleAllowAfterRegistrationPeriod = "ToggleAllowAfterRegistrationPeriod",
    ResetAfterRegistrationPeriod = "ResetAfterRegistrationPeriod",
    SaveApprovalStates = "SaveApprovalStates",
    SaveWaitingListStates = "SaveWaitingListStates",
    AcceptWaitingListApproval = "AcceptWaitingListApproval",
    UploadTeamFile = "UploadTeamFile",
    ApproveTeamFile = "ApproveTeamFile",
    UpdateFinalizationMembersCount = "UpdateFinalizationMembersCount",
    FinalizeTeamsUpdateTeam = "FinalizeTeamsUpdateTeam",
    CancelTeamMembers = "CancelTeamMembers",
    CreateAdditionalCost = "CreateAdditionalCost",
    DeleteAdditionalCost = "DeleteAdditionalCost",
    ViewAdditionalCosts = "ViewAdditionalCosts",
    ChangeRequestCreateMembers = "ChangeRequestCreateMembers",
    ChangeRequestCreateCategory = "ChangeRequestCreateCategory",
    ChangeRequestCreateCategoryWithMembers = "ChangeRequestCreateCategoryWithMembers",
    ChangeRequestApprove = "ChangeRequestApprove",
    ChangeRequestDecline = "ChangeRequestDecline",
    ChangeRequestCancel = "ChangeRequestCancel",
    CreateOrderPayment = "CreateOrderPayment",
    SubmitPaidOrder = "SubmitPaidOrder",
    BookManualPayment = "BookManualPayment",
    FetchPayments = "FetchPayments",
    CreateRefund = "CreateRefund",
    CreatePosPayment = "CreatePosPayment",
    CancelTeamRequest = "CancelTeamRequest",
    CancelTeamApprove = "CancelTeamApprove",
    AcceptBid = "AcceptBid"
}
